import { Ticket } from "../entities/ticket";
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class TicketRequest extends BaseRequest{

	constructor(userInfo : UserInfo){    
		super(userInfo)
	}
	
	ticket : Ticket;
}